import { Box } from '@mui/material'
import { Outlet } from 'react-router-dom'
import { navbarStyles } from './NavbarStyles'
import NavbarHeader from './NavbarHeader'
import useMenuState from '../../hooks/useMenuState'
import useNavigation from '../../hooks/useNavigation'

const NavbarComponent: React.FC = () => {
   const { navigateTo } = useNavigation()
   const { anchorEl, open, handleClick, handleClose } = useMenuState()

   return (
      <Box sx={navbarStyles.container}>
         <NavbarHeader
            navigateTo={navigateTo}
            anchorEl={anchorEl}
            open={open}
            handleClick={handleClick}
            handleClose={handleClose}
         />
         <Box sx={navbarStyles.content}>
            <Outlet />
         </Box>
      </Box>
   )
}

export default NavbarComponent
